import {
  COMPANY_ADDRESS,
  COMPANY_NAME,
  COMPANY_PHONE,
  PRIVACY_NOTICE_VERSION,
} from "../config";

export function PrivacyPage() {
  return (
    <article className="legal-page">
      <span className="eyebrow">Documento legal</span>
      <h1>Aviso de privacidad integral</h1>
      <p className="legal-page__updated">
        Versión y última actualización: {PRIVACY_NOTICE_VERSION}
      </p>

      <h2>Responsable y domicilio</h2>
      <p>
        {COMPANY_NAME}, con domicilio en {COMPANY_ADDRESS}, es responsable del
        tratamiento y protección de los datos personales recabados por esta
        calculadora.
      </p>

      <h2>Datos que tratamos</h2>
      <p>
        Puedes calcular sin crear una cuenta. En ese caso, los datos capturados
        se procesan en tu dispositivo y no se guardan en nuestra base de datos.
        Si decides crear una cuenta para conservar resultados, tratamos:
      </p>
      <ul>
        <li>correo electrónico e identificador técnico de la cuenta;</li>
        <li>
          entradas, resultados, títulos y fechas de los cálculos que elijas
          guardar;
        </li>
        <li>
          registros técnicos de seguridad, como fecha, dirección IP y eventos
          de autenticación.
        </li>
      </ul>
      <p>
        La herramienta no solicita nombre, RFC, CURP, NSS, domicilio de la
        persona trabajadora ni documentos. Te pedimos no escribir esos datos en
        los títulos o campos libres.
      </p>

      <h2>Finalidades necesarias</h2>
      <ul>
        <li>proporcionar los cálculos solicitados;</li>
        <li>crear, autenticar y proteger tu cuenta;</li>
        <li>guardar, mostrar, exportar, duplicar o eliminar tus cálculos;</li>
        <li>prevenir abuso, atender incidentes y mantener el servicio;</li>
        <li>cumplir obligaciones legales y responder a autoridad competente.</li>
      </ul>
      <p>
        No usamos los cálculos guardados para publicidad, perfiles comerciales
        ni decisiones automatizadas sobre empleo. No vendemos datos personales.
      </p>

      <h2>Encargados, transferencias y ubicación</h2>
      <p>
        Usamos servicios de Amazon Web Services para autenticación,
        almacenamiento, distribución y monitoreo. AWS actúa como encargado bajo
        contrato y puede tratar información en infraestructura ubicada en
        Estados Unidos. No realizamos transferencias a terceros para finalidades
        propias, salvo obligación legal o consentimiento de la persona titular.
      </p>

      <h2>Conservación y seguridad</h2>
      <p>
        Los cálculos se conservan mientras mantengas la cuenta o hasta que los
        elimines. Al eliminar tu cuenta se suprimen los cálculos activos; podrán
        existir copias transitorias en respaldos y registros de seguridad
        durante los plazos técnicos o legales aplicables. Aplicamos cifrado en
        tránsito y reposo, control de acceso por usuario, registros de auditoría
        y privilegios mínimos.
      </p>

      <h2>Derechos ARCO, revocación y limitación</h2>
      <p>
        Puedes acceder y exportar tus cálculos desde “Mis cálculos”, eliminarlos
        individualmente o eliminar tu cuenta. También puedes solicitar acceso,
        rectificación, cancelación u oposición, revocar tu consentimiento o
        limitar el tratamiento mediante escrito presentado en {COMPANY_ADDRESS}{" "}
        o comunicándote al {COMPANY_PHONE}. La solicitud deberá permitir
        acreditar identidad, identificar la cuenta y describir el derecho que
        deseas ejercer. Responderemos dentro de los plazos legales.
      </p>

      <h2>Cambios al aviso</h2>
      <p>
        Las modificaciones se publicarán en esta misma dirección electrónica,
        indicando la nueva fecha y versión. Si un cambio requiere consentimiento
        adicional, lo solicitaremos antes de aplicarlo.
      </p>
    </article>
  );
}

